import { createSlice } from '@reduxjs/toolkit'
import { setGlitchTipUser } from '../../monitoring/glitchtip'
import LoginResult from '../../types/api/auth/responses/login-result'
import { tokenStorage } from '../../services/token-storage'
import { userStorage } from '../../services/user-storage'
import { authApi } from '../api/auth-api'

const initialState: Partial<LoginResult> = {
    jwt: tokenStorage.get(),
    user: userStorage.get(),
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        resetAuth(state) {
            tokenStorage.remove()
            userStorage.remove()
            setGlitchTipUser(null)
            state.jwt = ''
            state.user = undefined
        },
    },
    extraReducers(builder) {
        builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, { payload }) => {
            tokenStorage.set(payload.jwt)
            userStorage.set(payload.user)
            setGlitchTipUser(payload.user)
            state.jwt = payload.jwt
            state.user = payload.user
        })
    },
})

export const { resetAuth } = authSlice.actions
export default authSlice.reducer
